import { useMemo } from 'react';
import classNames from 'classnames';

type SectionIntroProps = {
	readonly className?: string;
	readonly text: string;
};

const classNameComponent = 'c-cnm-section-intro';

export const SectionIntro = ({ className, text }: SectionIntroProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	return <p className={wrapperClassName}>{text}</p>;
};
